import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SLICE_STATUS } from 'utils/constants';
import {
  fetchNavItems,
  selectNavItemsStatus,
} from 'state/Navigation/navigationSlice';

// The backend can serve nav visibility computed from not-yet-initialized
// feature-flag state (e.g. right after a deploy). Refetching on window focus
// lets the client recover without a full page refresh, throttled so rapid
// tab switching doesn't hammer the endpoint.
export const NAV_REFETCH_MIN_INTERVAL_MS = 30000;

const useFetchNavItems = (): void => {
  const dispatch = useDispatch();
  const navItemsStatus = useSelector(selectNavItemsStatus);
  const lastFetchTimeRef = useRef<number>(0);

  useEffect(() => {
    if (navItemsStatus === SLICE_STATUS.IDLE) {
      lastFetchTimeRef.current = Date.now();
      dispatch(fetchNavItems());
    }
  }, [navItemsStatus, dispatch]);

  useEffect(() => {
    const refetchOnFocus = () => {
      const isFetching = navItemsStatus === SLICE_STATUS.LOADING;
      const isThrottled =
        Date.now() - lastFetchTimeRef.current < NAV_REFETCH_MIN_INTERVAL_MS;

      if (!isFetching && !isThrottled) {
        lastFetchTimeRef.current = Date.now();
        dispatch(fetchNavItems());
      }
    };

    window.addEventListener('focus', refetchOnFocus);
    return () => window.removeEventListener('focus', refetchOnFocus);
  }, [navItemsStatus, dispatch]);
};

export default useFetchNavItems;
